import { IUser } from "user/model"
import { userRPO } from "user/repository"
import { getUserAgency } from "./common"

export const getMyAgencyMembers = (): Promise<IUser[]> => userRPO.getAgencyUsers(getUserAgency().id)
